import { createTheme } from "@mui/material";
import background from "../assets/background.png";

export const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundImage: `url(${background})`,
          backgroundRepeat: "repeat-x"
        }
      }
    }
  }
});
